import React from "react";
import { useState, useEffect } from "react";
//import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import axios from "axios";
import "./ProfileForm.css";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Chip from "@mui/material/Chip";
import { Helmet } from "react-helmet";

import Navbarlogedin from "./Navbarlogedin";
import data from "./data.js";
import { Button } from "@mui/material";

function getStyles(name, profile, theme) {
  return {
    fontWeight:
      profile.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ProfileForm = () => {
  // console.log(user);
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  // let navigate = useNavigate();
  // console.log(data);

  const [profiledata, setProfileData] = useState("");
  useEffect(() => {
    async function fetchData() {
      await axios
        .get(
          `${process.env.REACT_APP_SERVER_URL}/send/student/112964740830785165733`
        )
        .then((response) => {
          setProfileData(response.data);
        })
        .catch((error) => {
          console.log("ERROR");
          console.log(error);
        });
    }
    fetchData();
  }, []);

  const theme = useTheme();

  // Profile Preference
  const [profile, setProfile] = React.useState([]);

  const handlePrefChange = (event) => {
    const {
      target: { value },
    } = event;
    setProfile(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    console.log(profile);
  };
  const handleDelete = (label) => {
    setProfile(
      profile.filter(function (item) {
        return item !== label;
      })
    );
  };

  const [inputs, setInputs] = useState({
    title: "",
    dfname: "",
    dlname: "",
    email: "",
    mobNumber: "",
    message: "",
    institute: "",
    program: "",
    branch: "",
    specialization: "",
    project: "",
    companies: "",
    linkedin: "",
    github: "",
    twitter: "",
  });
  const [pfpImage, setpfpImage] = useState(null);
  // Fatching User's Profile Photo
  // const [image, setImage] = useState();
  // useEffect(() => {
  //   const imageUrl = user.thumbNail;

  //   fetch(imageUrl)
  //     .then((response) => response.blob())
  //     .then((imageBlob) => {
  //       setImage(URL.createObjectURL(imageBlob));
  //       console.log("image: ", image);
  //     });
  // }, []);

  // Prefilling Few Fields
  // const prefilled = () => {
  //   setInputs((prevState) => ({
  //     ...prevState,
  //     dfname: localStorage.getItem("isAuthenticated").username.split(" ")[0],
  //     dlname: localStorage.getItem("isAuthenticated").username.split(" ")[1],
  //     // dp: user.thumbNail,
  //   }));
  //   if (localStorage.getItem("isAuthenticated").email.includes("@gmail.com")) {
  //     setInputs((prevState) => ({
  //       ...prevState,
  //       email: localStorage.getItem("isAuthenticated").email,
  //     }));
  //   }
  // };
  // useEffect(() => {
  //   prefilled();
  // }, []);
  // useEffect(() => {
  //   console.log(inputs);
  // }, [inputs]);

  // Handling Change
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs({ ...inputs, [name]: value });
  };

  // Count No of Digits
  const Count = (n) => {
    var count = 0;
    if (n >= 1) ++count;

    while (n / 10 >= 1) {
      n /= 10;
      ++count;
    }
    return count;
  };

  // Targeted Companies Object
  // E.g. [{company: "google", profile: "data science", fileJD: "", textJD: ""}]
  const [targetedCompanies, setTargetedCompanies] = useState([
    { company: "", profile: "", fileJD: "", textJD: "" },
  ]);
  // Handle Change for Targeted Companies
  const handleChangeTargetedCompanies = (index, profile, value) => {
    let tarComObj = [...targetedCompanies];
    tarComObj[index][profile] = value;
    setTargetedCompanies(tarComObj);
  };

  // Handle Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputs.email.includes("@gmail")) {
      // console.log("yes");
      document.getElementById("email-field").style.borderColor = "#FF0000";
      return window.alert("Please enter a Gmail address only!");
    }
    if (!inputs.email.endsWith("@gmail.com")) {
      // console.log("yes");
      document.getElementById("email-field").style.borderColor = "#FF0000";
      return window.alert("Please enter a valid Gmail address!");
    }

    if (!(Count(inputs.mobNumber) === 10)) {
      // console.log("yes");
      document.getElementById("mob-field").style.borderColor = "#FF0000";
      return window.alert("Please enter a valid 10 digit mobile number!");
    }

    const userData = {
      dfname: inputs.dfname,
      dlname: inputs.dlname,
      email: inputs.email,
      mobNumber: inputs.mobNumber,
      institute: inputs.institute,
      program: inputs.program,
      branch: inputs.branch,
      profilePreference: profile,
      specialization: inputs.specialization,
    };

    console.log(inputs, profile);
    console.log(userData);
    console.log(targetedCompanies);

    // axios
    //   .patch(`http://localhost:8585/send/profile/${user.Id}`, userData)
    //   .then((response) => {
    //     console.log(response.status);
    //     console.log(response.data);
    //   });
    window.alert("Your Details will be updated?");
  };

  return (
    <>
      <Helmet>
        <title>Interwiu | Edit Profile</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <div className="profile-form py-1">
        <h1 className="text-2xl font-medium text-center py-4 leading-3 text-blue-500">
          You're just a step away from scheduling your first Mock Interview!
        </h1>
        <form onSubmit={handleSubmit}>
          {/* Profile Form Container */}

          <div className="profile-form-cont">
            {/* Col-70 */}

            <div className="profile-form-text">
              {/* First Name and Last Name */}

              <div className="name cust-row flex">
                <div className="element" style={{ width: "auto" }}>
                  <label htmlFor="title">
                    Title<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    name="title"
                    value={inputs.title}
                    onChange={handleChange}
                    autoWidth
                    sx={{ padding: "0px", height: "56px" }}
                  >
                    <MenuItem value="mr">Mr.</MenuItem>
                    <MenuItem value="mrs">Ms.</MenuItem>
                    <MenuItem value="dr">Dr.</MenuItem>
                    <MenuItem value="prof">Prof.</MenuItem>
                  </Select>
                </div>
                <div className="element">
                  <label htmlFor="firstname">
                    First Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="dfname"
                    className="border-2 rounded"
                    required
                    value={inputs.dfname}
                    onChange={handleChange}
                    placeholder="First Name"
                    style={{ height: "56px" }}
                  />
                </div>
                <div className="element">
                  <label htmlFor="lastname">
                    Last Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="dlname"
                    className="border-2 rounded"
                    value={inputs.dlname}
                    onChange={handleChange}
                    placeholder="Last Name"
                    style={{ height: "56px" }}
                  />
                </div>
              </div>

              {/* Email and Mobile Number */}

              <div className="email cust-row flex">
                <div className="element">
                  <label htmlFor="email">
                    Email (only Gmail)<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email-field"
                    className="border-2 rounded"
                    value={inputs.email}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    required
                    placeholder="Email"
                    style={{ height: "56px" }}
                  />
                </div>
                <div className="element">
                  <label htmlFor="number">
                    Mobile Number<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    name="mobNumber"
                    id="mob-field"
                    className="border-2 rounded"
                    value={inputs.mobNumber}
                    onChange={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      handleChange(e);
                    }}
                    required
                    placeholder="+91 (10 Digit No)"
                    autoComplete="nope"
                    style={{ height: "56px" }}
                  />
                </div>
              </div>

              {/* Institution */}

              <div className="institution cust-row flex">
                <div className="element">
                  <label htmlFor="institute">
                    Institute<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    value={inputs.institute}
                    name="institute"
                    onChange={handleChange}
                    displayEmpty
                    required
                    MenuProps={MenuProps}
                    sx={{ width: 1 }}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem hidden disabled value="">
                      Select Institute
                    </MenuItem>
                    {data[0].institute?.map((item) => {
                      return <MenuItem value={item}>{item}</MenuItem>;
                    })}
                  </Select>
                </div>
                <div className="element">
                  <label htmlFor="program">
                    Program<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    value={inputs.program}
                    name="program"
                    onChange={handleChange}
                    displayEmpty
                    required
                    MenuProps={MenuProps}
                    sx={{ width: 1 }}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem hidden disabled value="">
                      Select Program
                    </MenuItem>
                    <MenuItem value="btech">B.Tech</MenuItem>
                    <MenuItem value="dual">
                      Dual Degree (B.Tech + M.Tech)
                    </MenuItem>
                    <MenuItem value="dualbsms">Dual Degree (BS + MS)</MenuItem>
                    <MenuItem value="mtech">M.Tech</MenuItem>
                    <MenuItem value="ms">MS (by Research)</MenuItem>
                    <MenuItem value="mba">MBA</MenuItem>
                    <MenuItem value="msc">M.Sc</MenuItem>
                    <MenuItem value="ima">Intergrated MA</MenuItem>
                    <MenuItem value="phd">PhD</MenuItem>
                  </Select>
                </div>
              </div>

              {/* Branch and Specialization */}

              <div className="branch cust-row flex">
                <div className="element">
                  <label htmlFor="branch">
                    Branch/Department<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    value={inputs.branch}
                    name="branch"
                    onChange={handleChange}
                    displayEmpty
                    required
                    MenuProps={MenuProps}
                    sx={{ width: 1 }}
                    inputProps={{ "aria-label": "Without label" }}
                    style={{ textOverflow: "ellipsis" }}
                  >
                    <MenuItem hidden disabled value="">
                      Select Branch/Department
                    </MenuItem>
                    {data[1][inputs.institute]?.map((item) => {
                      return (
                        <MenuItem
                          value={item}
                          key={data[1][inputs.institute].indexOf(item)}
                          style={{ textOverflow: "ellipsis" }}
                        >
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </div>
              </div>

              {/* Specialization */}

              <div className="branch cust-row flex">
                <div className="element w-50">
                  <label htmlFor="specialization">
                    Specialization (if applicable)
                  </label>
                  <input
                    type="text"
                    name="specialization"
                    className="border-2 rounded"
                    placeholder="Specialization"
                    style={{ height: "56px" }}
                    value={inputs.specialization}
                    onChange={handleChange}
                    autoComplete="nope"
                  />
                </div>
              </div>

              {/* Project Title */}

              <div className="project cust-row flex">
                <div className="element">
                  <label htmlFor="project">
                    B.Tech/Dual Degree/M.Tech/MS/PhD Project Title
                  </label>
                  <input
                    type="text"
                    className="border-2 rounded"
                    name="project"
                    placeholder="Project Title"
                    value={inputs.project}
                    onChange={handleChange}
                    autoComplete="nope"
                    style={{ height: "56px" }}
                  />
                </div>
              </div>

              {/* Profile Preference */}

              <div className="profilepref cust-row flex">
                <div className="element">
                  <label htmlFor="profilepreference">Profile Preferences</label>
                  <div className="flex">
                    <Select
                      multiple
                      displayEmpty
                      required
                      value={profile}
                      sx={{ width: 1 }}
                      renderValue={() => "Select Preferences"}
                      onChange={handlePrefChange}
                      MenuProps={MenuProps}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="Data Science">Data Science</MenuItem>
                      <MenuItem value="Software">Software</MenuItem>
                      <MenuItem value="Banking and Finance">
                        Banking and Finance
                      </MenuItem>
                      <MenuItem value="Consulting">Consulting</MenuItem>
                      <MenuItem value="Analytics">Analytics</MenuItem>
                      <MenuItem value="Product Management">
                        Product Management
                      </MenuItem>
                    </Select>
                    <div className="profile-pref-list rounded p-2">
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {profile.map((value) => (
                          <Chip
                            key={value}
                            label={value}
                            onDelete={() => {
                              handleDelete(value);
                            }}
                          />
                        ))}
                      </Box>
                    </div>
                  </div>
                </div>
              </div>

              {/* Targeted Companies */}

              <div className="w-full gap-2 text-lg mt-2 flex">
                <div className="element">
                  <label htmlFor="companies">
                    Targeted Companies and Profiles
                  </label>
                  <div>
                    {targetedCompanies?.map((item, index) => (
                      <div className="relative rounded border p-2 my-2">
                        <div className="absolute top-1 right-1">
                          <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                              setTargetedCompanies(
                                targetedCompanies.filter(function (sItem) {
                                  return sItem !== item;
                                })
                              );
                            }}
                          >
                            <CancelIcon fontSize="medium" />
                          </IconButton>
                        </div>
                        <div className="relative flex gap-5 mt-4 mb-2 w-full">
                          <div>
                            <label htmlFor="company">Company</label>
                            <input
                              type="text"
                              className="border-2 rounded w-full p-2"
                              name="targeted-company"
                              placeholder="Company"
                              value={item.company}
                              onChange={(e) => {
                                handleChangeTargetedCompanies(
                                  index,
                                  "company",
                                  e.target.value
                                );
                              }}
                              autoComplete="nope"
                              style={{ height: "56px" }}
                            />
                          </div>
                          <div>
                            <label htmlFor="targeted-profile">Profile</label>
                            <input
                              type="text"
                              className="border-2 rounded w-full p-2"
                              name="targeted-profile"
                              placeholder="Profile"
                              value={item.profile}
                              onChange={(e) => {
                                handleChangeTargetedCompanies(
                                  index,
                                  "profile",
                                  e.target.value
                                );
                              }}
                              autoComplete="nope"
                              style={{ height: "56px" }}
                            />
                          </div>
                        </div>
                        <div>
                          <label htmlFor="attachJD">
                            Add Job Description (JD)
                          </label>
                          <div className="flex gap-5">
                            <input
                              type="file"
                              name="attachJD"
                              id="attachJD"
                              className="block w-40 p-2 text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100"
                              accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                              value={inputs.resume}
                              onChange={(e) => {
                                const value = e.target.files[0];
                                handleChangeTargetedCompanies(
                                  index,
                                  "fileJD",
                                  value
                                );
                                setpfpImage({ pfpImage: value });
                                console.log(pfpImage.pfpImage);
                                var image = document.querySelector(".upload");
                                image.src = URL.createObjectURL(
                                  e.target.files[0]
                                );
                              }}
                            />
                            <p>OR</p>
                            <textarea
                              name="targeted-textJD"
                              id="targeted-textJD"
                              cols="30"
                              rows="3"
                              value={item.textJD}
                              onChange={(e) => {
                                handleChangeTargetedCompanies(
                                  index,
                                  "textJD",
                                  e.target.value
                                );
                              }}
                              placeholder="Enter your Job Description"
                              className="border p-1 focus:outline-none resize-none w-full"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    ))}
                    <Button
                      variant="contained"
                      onClick={() => {
                        setTargetedCompanies([
                          ...targetedCompanies,
                          {
                            company: "",
                            profile: "",
                            fileJD: "",
                            textJD: "",
                          },
                        ]);
                      }}
                    >
                      Add More JD
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            {/* Col-30 */}

            <div className="profile-form-profile">
              {/* Profile Photo */}

              <div className="profile-photo border rounded-md p-2">
                <Typography
                  variant="h5"
                  component="h5"
                  style={{
                    margin: "10px",
                    fontFamily: "'Ubuntu', sans-serif",
                  }}
                >
                  Profile Photo
                </Typography>
                <img
                  src={
                    JSON.parse(localStorage.getItem("isAuthenticated"))
                      .thumbNail
                  }
                  className="upload"
                  alt="Upload"
                />
                <input
                  type="file"
                  name="dp"
                  id="dp"
                  className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100"
                  value={inputs.dp || ""}
                  // required
                  accept="image/png, image/jpg, image/jpeg, image/url"
                  onChange={(e) => {
                    const value = e.target.files[0];
                    console.log(value);
                    setpfpImage({ pfpImage: value });
                    console.log(pfpImage.pfpImage);
                    var image = document.querySelector(".upload");
                    image.src = URL.createObjectURL(e.target.files[0]);
                  }}
                />
                <button
                  onClick={() => {
                    const imageData = {
                      name: "pfpImage.name",
                      testImage: pfpImage.pfpImage,
                    };
                    // console.log(pfpImage.name)
                    console.log(imageData);
                    const fd = new FormData();
                    fd.append("name", imageData.name);
                    fd.append("testImage", pfpImage.pfpImage);
                    console.log(fd);
                    axios
                      .post(`${process.env.REACT_APP_SERVER_URL}/pfpupload`, fd)
                      .then((response) => {
                        window.alert("Successfully uploaded");
                        console.log(response);
                      })
                      .catch((error) => {
                        window.alert("Error");
                        console.log("ERROR");
                        console.log(error);
                      });
                  }}
                >
                  Upload
                </button>
              </div>
              {/* Profile Resume */}

              <div className="profile-resume border rounded-md p-2">
                <Typography
                  variant="h5"
                  component="h5"
                  style={{ margin: "10px", fontFamily: "'Ubuntu', sans-serif" }}
                >
                  Resume<span style={{ color: "red" }}>*</span>
                </Typography>
                <button
                  className="cust-btn resume-btn"
                  style={{ display: "none" }}
                >
                  <a href="#" target="_black" className="resume-a">
                    <i className="fa-solid fa-file"></i> Resume
                  </a>
                </button>
                <input
                  type="file"
                  name="resume"
                  id="resume"
                  className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100"
                  accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  value={inputs.resume}
                  required
                  onChange={(e) => {
                    const value = e.target.files[0];
                    console.log(value);
                    setpfpImage({ pfpImage: value });
                    console.log(pfpImage.pfpImage);
                    var image = document.querySelector(".upload");
                    image.src = URL.createObjectURL(e.target.files[0]);
                  }}
                />
                <button
                  onClick={() => {
                    const imageData = {
                      name: "pfpImage.name",
                      testImage: pfpImage.pfpImage,
                    };
                    // console.log(pfpImage.name)
                    console.log(imageData);
                    const fd = new FormData();
                    fd.append("name", imageData.name);
                    fd.append("testImage", pfpImage.pfpImage);
                    console.log(fd);
                    axios
                      .post(`${process.env.REACT_APP_SERVER_URL}/pfpupload`, fd)
                      .then((response) => {
                        window.alert("Successfully uploaded");
                        console.log(response);
                      })
                      .catch((error) => {
                        window.alert("Error");
                        console.log("ERROR");
                        console.log(error);
                      });
                  }}
                >
                  Upload
                </button>
              </div>
              <div className="my-3 p-2 border rounded-md text-left">
                <Typography
                  variant="h5"
                  component="h5"
                  align="center"
                  style={{ margin: "10px", fontFamily: "'Ubuntu', sans-serif" }}
                >
                  Social Links
                </Typography>
                <div className="my-3">
                  <label htmlFor="linkedin">
                    <i className="fa-brands fa-linkedin"></i> LinkedIn
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="url"
                    name="linkedin"
                    id="linkedin"
                    required
                    className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                    placeholder="LinkedIn URL"
                  />
                </div>
                <div className="my-3">
                  <label htmlFor="linkedin">
                    <i className="fa-brands fa-github"></i> GitHub
                  </label>
                  <input
                    type="url"
                    name="github"
                    id="github"
                    className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                    placeholder="GitHub URL"
                  />
                </div>
                <div className="my-3">
                  <label htmlFor="linkedin">
                    <i className="fa-brands fa-twitter"></i> Twitter
                  </label>
                  <input
                    type="url"
                    name="twitter"
                    id="twitter"
                    className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                    placeholder="Twitter URL"
                  />
                </div>
              </div>
            </div>
          </div>
          <button type="submit" className="cust-btn create-btn">
            Update Details
          </button>
        </form>
      </div>
    </>
  );
};

export default ProfileForm;
